import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';

import {Badge, Text} from '@albert-io/atomic';

import SchoolV5Schema from 'resources/augmented/School/schemas/school_v5.schema.json';

import ZipcodeInput from './ZipcodeInput.react';
import SchoolFilterDropdown from './SchoolFilterDropdown.react';

const SchoolChipFilters = ({
  countrySearchValue,
  setCountrySearchValue,
  stateSearchValue,
  setStateSearchValue,
  postalcodeSearchValue,
  setPostalcodeSearchValue
}) => {
  const USA = 'United States of America';
  const [showZipcodePopover, setShowZipcodePopover] = useState(false);
  const popoverRef = useRef();

  // Move USA to top of list with shortened value and filter out the created object from schools schema
  const countryOptions = [
    {label: 'Any country', value: undefined},
    {label: 'USA', value: USA},
    ...SchoolV5Schema.properties.data.properties.attributes.properties.country.enum.map((item) => ({
      label: item,
      value: item
    }))
  ].filter((item) => item.label !== USA);

  const stateOptions = [
    {label: 'Any state', value: undefined},
    ...SchoolV5Schema.properties.data.properties.attributes.properties.state.enum.map((item) => ({
      label: item,
      value: item
    }))
  ];

  return (
    <div className='school-lookup-modal__chip-container mt-x1 flex overflow-x-auto p-x1 m:flex-wrap m:overflow-x-visible'>
      <SchoolFilterDropdown
        label='Country'
        selected={countrySearchValue}
        options={countryOptions}
        onSelect={(option) => {
          if (setStateSearchValue) setStateSearchValue(undefined);
          if (setPostalcodeSearchValue) setPostalcodeSearchValue(undefined);
          setCountrySearchValue(option);
        }}
      />
      {countrySearchValue.value === USA && !!setStateSearchValue ? (
        <SchoolFilterDropdown
          label='State'
          selected={stateSearchValue}
          options={stateOptions}
          onSelect={(option) => {
            if (option.value === undefined) {
              setStateSearchValue(undefined);
            } else {
              setStateSearchValue(option);
            }
          }}
        />
      ) : null}
      {countrySearchValue.value === USA ? (
        <span ref={popoverRef} className='inline-block'>
          <Badge
            status='info'
            emphasis='subtle'
            icon={['fas', 'pencil-alt']}
            iconAlign='right'
            roundness='square'
            onClick={() => setShowZipcodePopover(!showZipcodePopover)}
          >
            ZIP code: {postalcodeSearchValue || 'Any'}
          </Badge>
          {showZipcodePopover && (
            <ZipcodeInput
              popoverRef={popoverRef}
              showZipcodePopover={showZipcodePopover}
              setShowZipcodePopover={setShowZipcodePopover}
              setPostalcodeSearchValue={setPostalcodeSearchValue}
              postalcodeSearchValue={postalcodeSearchValue}
            />
          )}
        </span>
      ) : null}
    </div>
  );
};

SchoolChipFilters.propTypes = {
  countrySearchValue: PropTypes.string,
  setCountrySearchValue: PropTypes.func,
  stateSearchValue: PropTypes.string,
  setStateSearchValue: PropTypes.func,
  postalcodeSearchValue: PropTypes.string,
  setPostalcodeSearchValue: PropTypes.func
};

export default SchoolChipFilters;
